import React, { useState, useEffect } from 'react';
import Footer from './components/Footer';
import Header from './components/Header';
import ScrollToTopBtn from './components/elements/ScrollToTopBtn';
import Homepage from './pages/Homepage';
import { Routes, Route } from 'react-router-dom';
import SplashScreen from './SplashScreen';

function App() {
  const [isSplashVisible, setIsSplashVisible] = useState(true);

  useEffect(() => {
    // Hide splash screen after 5 seconds
    const timer = setTimeout(() => setIsSplashVisible(false), 5000); // Set duration to 5 seconds
    return () => clearTimeout(timer); // Cleanup timer on unmount
  }, []);

  return (
    <div className="App">
      {isSplashVisible ? (
        <SplashScreen /> // No need to pass onComplete prop
      ) : (
        <>
          <Header />
          <Routes>
            {/* Homepage */}
            <Route path="/" exact element={<Homepage />} />
          </Routes>
          <Footer />
          <ScrollToTopBtn />
        </>
      )}
    </div>
  );
}

export default App;
